import styled from 'styled-components';
import { typographyStyle } from '../styled.js';

/* eslint-disable import/prefer-default-export */
var StyledSpan = styled.span.withConfig({
  displayName: "StyledSpan",
  componentId: "sc-kf3jj1-0"
})(["", ""], typographyStyle);

export { StyledSpan };
